import type { ReactElement } from "react";
import React from "react";
import Modal from "~/components/modal.tsx";
import { useTranslator } from "@brickme/frontend-common/src/i18n/translation.tsx";

type ConfirmStartNewProjectModalProps = {
	readonly show: boolean;
	readonly onConfirm: () => void;
	readonly onCancel: () => void;
};

function ConfirmStartNewProjectModal({
	show,
	onConfirm,
	onCancel,
}: ConfirmStartNewProjectModalProps): ReactElement {
	const t = useTranslator();
	return (
		<Modal show={show} title={t("WARNING!")} onClose={onCancel}>
			<Modal.Text>
				{t("Are you sure you want to start a new project?")}
			</Modal.Text>
			<Modal.Actions
				actions={[
					{ text: t("Cancel"), onClick: onCancel, type: "ghost" },
					{ text: t("Start over"), onClick: onConfirm },
				]}
			/>
		</Modal>
	);
}

export default ConfirmStartNewProjectModal;
